import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../_helpers';

// create slice

const name = 'users';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const userActions = { ...slice.actions, ...extraActions };
export const usersReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        users: {},
        usersList: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAll: getAll(),
        getAllByUser: getAllByUser()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/UsersList`)
        );
    }

    function getAllByUser() {
        return createAsyncThunk(
            `${name}/getAllByUser`,
            async () => await fetchWrapper.get(`${baseUrl}/EmployeesByUser`)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll(),
        ...getAllByUser()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.users = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.users = action.payload;
            },
            [rejected]: (state, action) => {
                state.users = { error: action.error };
            }
        };
    }

    function getAllByUser() {
        var { pending, fulfilled, rejected } = extraActions.getAllByUser;
        return {
            [pending]: (state) => {
                state.usersList = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.usersList = action.payload;
            },
            [rejected]: (state, action) => {
                state.usersList = { error: action.error };
            }
        };
    }
}
